import { TabsOrientation } from '@reach/tabs';
import { createContext } from 'react';

const initialContext = {
  changeTab: () => console.log('Warning: changeTab is not implemented'),
  activeTab: 0,
  orientation: TabsOrientation.Horizontal,
};

interface SideEditorContextValues {
  activeTab: number;
  changeTab: (newTab: number) => void;
  orientation: TabsOrientation;
}

export const sideEditorContext = createContext<SideEditorContextValues>(initialContext);
